<template>
    <div>
       
        <section class="Login_page" style="background-image: url(Images/Background/Background_img.png);">
        <div class="container d-flex justify-content-end align-items-center min-vh-100">
            <div class="login-box  py-xl-4 px-xl-5">
                <div class="logo">
                    <img src="@/assets/Images/Logo/kims-logo.png" alt="KIMS Health Logo" >
                </div>
                <div class="login_textbox p-xl-4">
                    <h4 class="pt-2">Welcome to</h4>
                    <h1 class="my-1"><span class="bold">KIMS</span>HEALTH</h1>
                    <h4>VISA Medical Online Appointments</h4>
                </div>
                <div class="container py-4">
                    <div class="row">
                        
                        <div class="col-md-6"  v-for="entity in entities" :key="entity.id">
                            <div class="country-card d-flex align-items-center">
                                <img :src="entity.image" :alt="entity.title" class="country-img" />
                                <span class="ms-2 flex-grow-1">{{ entity.title }}</span>
                                <a :href="`${bookAppointment}/${entity.id}`" class="book-btn">BOOK NOW</a>
                            </div>
                        </div>
                        <div v-if="!entities.length">
                            <p>No records found.</p>
                        </div>
                       
                    </div>
                </div>
                <div class="track_text ps-2">
                    <small  v-if="hometext">{{ hometext }}</small>
                    <h6 class="text-center mt-5 mb-3 ">Would you like to track your appointment?</h6>
                    <a :href="trackAppointment" class="btn track-btn py-3 " style="text-decoration: none;">Track Appoinments(s)</a>
                </div>
                <!-- Track Appointment  -->
                <div class="bottom-links mt-2 pt-3">
                    <a :href="trackAppointment" >Track Appointment</a> | 
                    <a :href="privacy_policy" class="ms-1">Privacy Policy</a> | 
                    <!-- <a href="https://visamedical.kimshealth.org/refund-policy" class="ms-1">Refund Policy</a> |  -->
                    <a :href="terms_and_conditions" class="ms-1">Terms & Conditions</a>
                </div>
            </div>
        </div>
    </section>
    

    </div>
  </template>
  
  <script>
  import { mapState } from 'vuex';
  import { GetEntities, GetHomeText } from '@/api/Front/home';
  export default {
    name: 'LandingHomePage',
    data() {
        return {
            entities: [],
            hometext: '',
            trackAppointment : '/trackAppointment',
            bookAppointment : '/bookAppointment',
            privacy_policy : '/privacy-policy',
            terms_and_conditions : '/terms-conditions',
        };
    },
    mounted() {
        this.loadEntities(); 
        this.homeText();
    },
    methods: {
        async loadEntities() {
            try {
                const response = await GetEntities();
                //console.log('Entities:', response.data);
                this.entities = response.data.data;
            } catch (error) {
                console.error('Failed to fetch entities:', error);
            }
        },
        async homeText() {
            try {
                const response = await GetHomeText();
                this.hometext = response.data.data;
            } catch (error) {
                console.error('Failed to fetch text:', error);
            }
        }
    }
  }
  </script>

